import React, { useState, useEffect, useContext } from "react";
import { UserInformationContext } from "../main/App";
import { C4FStatusContext } from "../main/App";
import { InfoModalContext } from "../main/App";
import '../css/general.css';
import { Container, Row, Col, Table } from 'react-bootstrap';
import SkillClimbing from "../img/icons/skill-climbing.png";
import SkillFlat from "../img/icons/skill-flat.png";
import SkillDownhill from "../img/icons/skill-downhill.png";
import SkillTimeTrial from "../img/icons/skill-timetrial.png";
import SkillSprint from "../img/icons/skill-sprint.png";
import SkillCobbles from "../img/icons/skill-cobbles.png";
import SkillRegeneration from "../img/icons/skill-regeneration.png";
import C4FSimpleTable from "../common/C4FSimpleTable";
import useWindowDimensions from "../WindowDimensions";

function Training(props) {

  const { userInformation } = useContext(UserInformationContext);
  const { handleBackendRequest } = useContext(C4FStatusContext);
  const { showRiderInfo } = useContext(InfoModalContext);
  const [refresh, doRefresh] = useState(0);
  const [riders, setRiders] = useState(null);
  const [ridersTraining, setRidersTraining] = useState(null);
  const [trainingHistory, setTrainingHistory] = useState([]);
  const [racerTeamSortBy, setRacerTeamSortBy] = useState('lastNames');
  const [racerTeamSortOrder, setRacerTeamSortOrder] = useState('asc');
  const { width } = useWindowDimensions();

  function handleRacerTeamSorting(sortBy) {
    let sortByChange = racerTeamSortBy !== sortBy;
    setRacerTeamSortBy(sortBy);
    setRacerTeamSortOrder((sortByChange) ? 'desc' : (racerTeamSortOrder === 'asc') ? 'desc' : 'asc');
  }

  function getProbabilityFormatStyle(probability) {
    if (probability > 0) return { fontWeight: "bold", color: "rgba(0, 156, 34, 1)" };
    if (probability < 0) return { fontWeight: "bold", color: "rgba(203, 6, 0, 1)" };
    return { fontWeight: "bold" };
  }

  function extractRidersTraining(riders) {
    let ridersTrainingLocal = [];
    riders.map(rider => {
      let riderTrainingSlots = [];
      let counter = 0;
      for (let i = 0; i < rider.training.Climbing.slots; i++) riderTrainingSlots[counter++] = 'Climbing';
      for (let i = 0; i < rider.training.Flat.slots; i++) riderTrainingSlots[counter++] = 'Flat';
      for (let i = 0; i < rider.training.Downhill.slots; i++) riderTrainingSlots[counter++] = 'Downhill';
      for (let i = 0; i < rider.training.TimeTrial.slots; i++) riderTrainingSlots[counter++] = 'TimeTrial';
      for (let i = 0; i < rider.training.Sprint.slots; i++) riderTrainingSlots[counter++] = 'Sprint';
      ridersTrainingLocal[rider.id] = riderTrainingSlots;
    });
    setRidersTraining(ridersTrainingLocal);
  }

  function updateRider(updatedRider) {
    let ridersLocal = [];
    riders.map(rider => {
      if (rider.id !== updatedRider.id)
        ridersLocal.push(rider);
      else
        ridersLocal.push(updatedRider);
    });
    setRiders(ridersLocal);
    extractRidersTraining(ridersLocal);
  }

  function loadTeam() {
    handleBackendRequest('GET', '/team/' + userInformation.userName, null, { returnRiders: true, returnTraining: true },
      function (teamResponse) {
        setRiders(teamResponse.riders);
        extractRidersTraining(teamResponse.riders);
        let trainingHistoryLocal = [];
        teamResponse.riders.forEach(r => r.trainingHistory && r.trainingHistory.forEach(th => trainingHistoryLocal.push({ riderId: r.id, riderName: r.firstNames + ' ' + r.lastNames, ...th })));
        setTrainingHistory(trainingHistoryLocal);
      });
  }

  const handleChangeForm = (e) => {
    let changedRider = e.target.getAttribute('id');
    // call server
    handleBackendRequest('POST', '/rider/' + changedRider + '/setFormPeak', {}, { formPeak: e.target.value },
      function (response) {
        updateRider(response);
        doRefresh(prev => prev + 1);
      });
  };

  const handleChangeTraining = (e) => {
    let ridersTrainingLocal = ridersTraining;
    let changedRider = e.target.getAttribute('id');
    ridersTrainingLocal[changedRider][e.target.getAttribute('slot')] = e.target.value;

    handleBackendRequest('POST', '/rider/' + changedRider + '/setTraining', {},
      {
        slot1: ridersTrainingLocal[changedRider][0],
        slot2: ridersTrainingLocal[changedRider][1],
        slot3: ridersTrainingLocal[changedRider][2],
        slot4: ridersTrainingLocal[changedRider][3],
        slot5: ridersTrainingLocal[changedRider][4],
        slot6: ridersTrainingLocal[changedRider][5],
        slot7: ridersTrainingLocal[changedRider][6]
      },
      function (response) {
        updateRider(response);
        doRefresh(prev => prev + 1);
      });
  };

  useEffect(() => {
    loadTeam();
  }, []);

  let today = new Date();
  let lastDayOfNextMonth = new Date(today.getFullYear(), today.getMonth() + 2, 0).getDate();
  let daysOfMonth = [];
  for (let day = 1; day <= lastDayOfNextMonth; day++) daysOfMonth[day] = day;

  if (riders !== null && ridersTraining !== null)
    return <div fluid className="m-0 p-0 justify-content-center">
      <div className="row d-flex ml-1 mt-1 p-1 justify-content-center">
        <div className="col p-1 mr-1"  >
          <h5><u>Form Settings for next month</u></h5>
          <div className="" style={{ minWidth: 540, maxWidth: "80vw", maxHeight: 600, overflow: "auto", backgroundColor: 'rgba(245,250,255,1)' }}>
            <Table key={'form' + refresh} striped size="sm" >
              <thead>
                <tr>
                  <th onClick={() => handleRacerTeamSorting('lastNames')} className="th-infotable sortable" scope="col" style={{ textAlign: "left" }}>Rider</th>
                  <th onClick={() => handleRacerTeamSorting('climbing')} className="th-infotable sortable" scope="col"><img src={SkillClimbing} title="Mountain" alt="Climbing" /></th>
                  <th onClick={() => handleRacerTeamSorting('flat')} className="th-infotable sortable" scope="col"><img src={SkillFlat} title="Flat" alt="Flat" /></th>
                  <th onClick={() => handleRacerTeamSorting('downhill')} className="th-infotable sortable" scope="col"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></th>
                  <th onClick={() => handleRacerTeamSorting('timeTrial')} className="th-infotable sortable" scope="col"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></th>
                  <th onClick={() => handleRacerTeamSorting('sprint')} className="th-infotable sortable" scope="col"><img src={SkillSprint} title="Sprint" alt="Sprint" /></th>
                  <th onClick={() => handleRacerTeamSorting('pave')} className="th-infotable sortable" scope="col"><img src={SkillCobbles} title="Cobbles" alt="Cobbles" /></th>
                  <th onClick={() => handleRacerTeamSorting('reg')} className="th-infotable sortable" scope="col"><img src={SkillRegeneration} title="Regeneration" alt="Regeneration" /></th>
                  <th onClick={() => handleRacerTeamSorting('age')} className="th-infotable sortable" scope="col">Age</th>
                  <th onClick={() => handleRacerTeamSorting('formpeak')} className="th-infotable sortable" scope="col">Form</th>
                </tr>
              </thead>
              <tbody>
                {riders.slice()
                  .sort(function (a, b) {
                    switch (racerTeamSortBy + ';' + racerTeamSortOrder) {
                      case 'lastNames;asc':
                        return a.lastNames.localeCompare(b.lastNames)
                          || a.firstNames.localeCompare(b.firstNames);
                      case 'lastNames;desc':
                        return b.lastNames.localeCompare(a.lastNames)
                          || b.firstNames.localeCompare(a.firstNames);
                      case 'climbing;asc': return a.skills.Climbing - b.skills.Climbing;
                      case 'climbing;desc': return b.skills.Climbing - a.skills.Climbing;
                      case 'flat;asc': return a.skills.Flat - b.skills.Flat;
                      case 'flat;desc': return b.skills.Flat - a.skills.Flat;
                      case 'downhill;asc': return a.skills.Downhill - b.skills.Downhill;
                      case 'downhill;desc': return b.skills.Downhill - a.skills.Downhill;
                      case 'timeTrial;asc': return a.skills.TimeTrial - b.skills.TimeTrial;
                      case 'timeTrial;desc': return b.skills.TimeTrial - a.skills.TimeTrial;
                      case 'sprint;asc': return a.skills.Sprint - b.skills.Sprint;
                      case 'sprint;desc': return b.skills.Sprint - a.skills.Sprint;
                      case 'pave;asc': return (a.skills.Cobbles * 0.3 + a.skills.Flat * 0.7) - (b.skills.Cobbles * 0.3 + b.skills.Flat * 0.7);
                      case 'pave;desc': return (b.skills.Cobbles * 0.3 + b.skills.Flat * 0.7) - (a.skills.Cobbles * 0.3 + a.skills.Flat * 0.7);
                      case 'reg;asc': return a.skills.Regeneration - b.skills.Regeneration;
                      case 'reg;desc': return b.skills.Regeneration - a.skills.Regeneration;
                      case 'age;asc': return a.age - b.age;
                      case 'age;desc': return b.age - a.age;
                      case 'formpeak;asc': return a.nextFormPeak - b.nextFormPeak;
                      case 'formpeak;desc': return b.nextFormPeak - a.nextFormPeak;
                      default: return a.lastNames.localeCompare(b.lastNames)
                        || a.firstNames.localeCompare(b.firstNames);
                    }
                  })
                  .filter(rider => rider.age > 20).map((rider, index) => (
                    <tr>
                      <td className="td-infotable" style={{ textAlign: "left" }}>
                        <a href="#" onClick={() => showRiderInfo(rider)} style={{ color: '#000000' }}>
                          {rider.firstNames + ' ' + rider.lastNames}
                        </a>
                      </td>
                      <td className="td-infotable">{rider.skills.Climbing}</td>
                      <td className="td-infotable">{rider.skills.Flat}</td>
                      <td className="td-infotable">{rider.skills.Downhill}</td>
                      <td className="td-infotable">{rider.skills.TimeTrial}</td>
                      <td className="td-infotable">{rider.skills.Sprint}</td>
                      <td className="td-infotable">{Math.round((rider.skills.Cobbles * 0.3 + rider.skills.Flat * 0.7) * 10) / 10}</td>
                      <td className="td-infotable">{rider.skills.Regeneration}</td>
                      <td className="td-infotable">{rider.age}</td>
                      <td className="td-infotable">
                        <select id={rider.id} value={rider.nextFormPeak} onChange={handleChangeForm}>
                          <option value="0">const.</option>
                          {daysOfMonth.map((day) => (
                            <option value={day}>{day}</option>
                          ))}
                        </select></td>
                    </tr>
                  )
                  )}
              </tbody>
            </Table>
          </div>
        </div>
        <div className="col m-1" >
          <h5 className="ml-2 text-left"><u>Training Results</u></h5>
          <C4FSimpleTable key={'trainingStats'}
            initialSortingColumn={'date'}
            initialSortingAscending={false}
            maxHeight={540}
            data={trainingHistory.map(th => ({
              ...th,
              resultFormatted: th.result === 1 ? '+1' : '-1'
            }))}
            hideColumnVisibility={true}
            rowMetadata={[
              { columnName: 'date', columnDescription: 'Date' },
              { columnName: 'riderName', columnDescription: 'Rider Name', cellClickEvent: showRiderInfo },
              { columnName: 'skill', columnDescription: 'Skill' },
              { columnName: 'resultFormatted', columnDescription: 'Result' }
            ]}
          />
        </div>
      </div>
      <div className="row d-flex mt-1 p-1 justify-content-center">

        {width > 1000 ?
          <Col className="m-0">
            <h5 className="text-left"><u>Training Settings &amp; Probabilities</u></h5>
            <div className="" style={{ backgroundColor: 'rgba(245,250,255,1)' }}>
              <Table key={'training' + refresh} className=" table-sm table-striped">
                <thead>
                  <tr style={{ minHeight: 32 }}>
                    <th onClick={() => handleRacerTeamSorting('lastNames')} className="th-infotable" scope="col" style={{ textAlign: "left" }}>Rider</th>
                    <th className="th-infotable" scope="col">Slot 1</th>
                    <th className="th-infotable" scope="col">Slot 2</th>
                    <th className="th-infotable" scope="col">Slot 3</th>
                    <th className="th-infotable" scope="col">Slot 4</th>
                    <th className="th-infotable" scope="col">Slot 5</th>
                    <th className="th-infotable" scope="col">Slot 6</th>
                    <th className="th-infotable" scope="col">Slot 7</th>
                    <th onClick={() => handleRacerTeamSorting('climbingProb')} className="th-infotable sortable" scope="col"><img src={SkillClimbing} title="Mountain" alt="Climbing" /></th>
                    <th onClick={() => handleRacerTeamSorting('flatProb')} className="th-infotable sortable" scope="col"><img src={SkillFlat} title="Flat" alt="Flat" /></th>
                    <th onClick={() => handleRacerTeamSorting('downhillProb')} className="th-infotable sortable" scope="col"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></th>
                    <th onClick={() => handleRacerTeamSorting('timeTrialProb')} className="th-infotable sortable" scope="col"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></th>
                    <th onClick={() => handleRacerTeamSorting('sprintProb')} className="th-infotable sortable" scope="col"><img src={SkillSprint} title="Sprint" alt="Sprint" /></th>
                  </tr>
                </thead>
                <tbody>
                  {riders.slice()
                    .sort(function (a, b) {
                      switch (racerTeamSortBy + ';' + racerTeamSortOrder) {
                        case 'lastNames;asc':
                          return a.lastNames.localeCompare(b.lastNames)
                            || a.firstNames.localeCompare(b.firstNames);
                        case 'lastNames;desc':
                          return b.lastNames.localeCompare(a.lastNames)
                            || b.firstNames.localeCompare(a.firstNames);
                        case 'climbingProb;asc': return a.training.Climbing.probability - b.training.Climbing.probability;
                        case 'climbingProb;desc': return b.training.Climbing.probability - a.training.Climbing.probability;
                        case 'flatProb;asc': return a.training.Flat.probability - b.training.Flat.probability;
                        case 'flatProb;desc': return b.training.Flat.probability - a.training.Flat.probability;
                        case 'downhillProb;asc': return a.training.Downhill.probability - b.training.Downhill.probability;
                        case 'downhillProb;desc': return b.training.Downhill.probability - a.training.Downhill.probability;
                        case 'timeTrialProb;asc': return a.training.TimeTrial.probability - b.training.TimeTrial.probability;
                        case 'timeTrialProb;desc': return b.training.TimeTrial.probability - a.training.TimeTrial.probability;
                        case 'sprintProb;asc': return a.training.Sprint.probability - b.training.Sprint.probability;
                        case 'sprintProb;desc': return b.training.Sprint.probability - a.training.Sprint.probability;
                        default: return a.lastNames.localeCompare(b.lastNames)
                          || a.firstNames.localeCompare(b.firstNames);
                      }
                    })
                    .filter(rider => rider.age > 20).map((rider, index) => (
                      <tr>
                        <td className="td-infotable" style={{ textAlign: "left" }}>
                          <a href="#" onClick={() => showRiderInfo(rider)} style={{ color: '#000000' }}>
                            {rider.firstNames + ' ' + rider.lastNames}
                          </a>
                        </td>
                        {
                          [0, 1, 2, 3, 4, 5, 6].map(slot => (
                            <td className="td-infotable" style={{ fontSize: "0.9em" }}>
                              <select size="sm" id={rider.id} slot={slot} value={ridersTraining[rider.id][slot]} onChange={handleChangeTraining}>
                                <option value="Climbing">MO</option>
                                <option value="Flat">FL</option>
                                <option value="Downhill">DH</option>
                                <option value="TimeTrial">TT</option>
                                <option value="Sprint">SP</option>
                              </select>
                            </td>
                          ))}
                        <td className="td-infotable px-3" style={getProbabilityFormatStyle(rider.training.Climbing.probability)}>{rider.training.Climbing.probability}%</td>
                        <td className="td-infotable px-3" style={getProbabilityFormatStyle(rider.training.Flat.probability)}>{rider.training.Flat.probability}%</td>
                        <td className="td-infotable px-3" style={getProbabilityFormatStyle(rider.training.Downhill.probability)}>{rider.training.Downhill.probability}%</td>
                        <td className="td-infotable px-3" style={getProbabilityFormatStyle(rider.training.TimeTrial.probability)}>{rider.training.TimeTrial.probability}%</td>
                        <td className="td-infotable px-3" style={getProbabilityFormatStyle(rider.training.Sprint.probability)}>{rider.training.Sprint.probability}%</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </Col>
          :
          <>
            <Col className="m-0">
              <h5 className="text-left"><u>Training Settings</u></h5>
              <div className="" style={{ backgroundColor: 'rgba(245,250,255,1)' }}>
                <Table key={'training' + refresh} className=" table-sm table-striped">
                  <thead>
                    <tr style={{ minHeight: 32 }}>
                      <th onClick={() => handleRacerTeamSorting('lastNames')} className="th-infotable" scope="col" style={{ textAlign: "left" }}>Rider</th>
                      <th className="th-infotable" scope="col">Slot 1</th>
                      <th className="th-infotable" scope="col">Slot 2</th>
                      <th className="th-infotable" scope="col">Slot 3</th>
                      <th className="th-infotable" scope="col">Slot 4</th>
                      <th className="th-infotable" scope="col">Slot 5</th>
                      <th className="th-infotable" scope="col">Slot 6</th>
                      <th className="th-infotable" scope="col">Slot 7</th>
                    </tr>
                  </thead>
                  <tbody>
                    {riders.slice()
                      .sort(function (a, b) {
                        switch (racerTeamSortBy + ';' + racerTeamSortOrder) {
                          case 'lastNames;asc':
                            return a.lastNames.localeCompare(b.lastNames)
                              || a.firstNames.localeCompare(b.firstNames);
                          case 'lastNames;desc':
                            return b.lastNames.localeCompare(a.lastNames)
                              || b.firstNames.localeCompare(a.firstNames);
                          case 'climbingProb;asc': return a.training.Climbing.probability - b.training.Climbing.probability;
                          case 'climbingProb;desc': return b.training.Climbing.probability - a.training.Climbing.probability;
                          case 'flatProb;asc': return a.training.Flat.probability - b.training.Flat.probability;
                          case 'flatProb;desc': return b.training.Flat.probability - a.training.Flat.probability;
                          case 'downhillProb;asc': return a.training.Downhill.probability - b.training.Downhill.probability;
                          case 'downhillProb;desc': return b.training.Downhill.probability - a.training.Downhill.probability;
                          case 'timeTrialProb;asc': return a.training.TimeTrial.probability - b.training.TimeTrial.probability;
                          case 'timeTrialProb;desc': return b.training.TimeTrial.probability - a.training.TimeTrial.probability;
                          case 'sprintProb;asc': return a.training.Sprint.probability - b.training.Sprint.probability;
                          case 'sprintProb;desc': return b.training.Sprint.probability - a.training.Sprint.probability;
                          default: return a.lastNames.localeCompare(b.lastNames)
                            || a.firstNames.localeCompare(b.firstNames);
                        }
                      })
                      .filter(rider => rider.age > 20).map((rider, index) => (
                        <tr>
                          <td className="td-infotable" style={{ textAlign: "left" }}>
                            <a href="#" onClick={() => showRiderInfo(rider)} style={{ color: '#000000' }}>
                              {rider.firstNames + ' ' + rider.lastNames}
                            </a>
                          </td>
                          {
                            [0, 1, 2, 3, 4, 5, 6].map(slot => (
                              <td className="td-infotable" style={{ fontSize: "0.9em" }}>
                                <select size="sm" id={rider.id} slot={slot} value={ridersTraining[rider.id][slot]} onChange={handleChangeTraining}>
                                  <option value="Climbing">MO</option>
                                  <option value="Flat">FL</option>
                                  <option value="Downhill">DH</option>
                                  <option value="TimeTrial">TT</option>
                                  <option value="Sprint">SP</option>
                                </select>
                              </td>
                            ))}
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </Col>
            <Col className="m-0">
              <h5 className="text-left"><u>Training Probabilities</u></h5>
              <div className="" style={{ backgroundColor: 'rgba(245,250,255,1)' }}>
                <Table key={'training' + refresh} className=" table-sm table-striped">
                  <thead>
                    <tr>
                      <th onClick={() => handleRacerTeamSorting('lastNames')} className="th-infotable sortable" scope="col" style={{ textAlign: "left" }}>Rider</th>
                      <th onClick={() => handleRacerTeamSorting('climbingProb')} className="th-infotable sortable" scope="col"><img src={SkillClimbing} title="Mountain" alt="Climbing" /></th>
                      <th onClick={() => handleRacerTeamSorting('flatProb')} className="th-infotable sortable" scope="col"><img src={SkillFlat} title="Flat" alt="Flat" /></th>
                      <th onClick={() => handleRacerTeamSorting('downhillProb')} className="th-infotable sortable" scope="col"><img src={SkillDownhill} title="Downhill" alt="Downhill" /></th>
                      <th onClick={() => handleRacerTeamSorting('timeTrialProb')} className="th-infotable sortable" scope="col"><img src={SkillTimeTrial} title="TimeTrial" alt="TimeTrial" /></th>
                      <th onClick={() => handleRacerTeamSorting('sprintProb')} className="th-infotable sortable" scope="col"><img src={SkillSprint} title="Sprint" alt="Sprint" /></th>
                    </tr>
                  </thead>
                  <tbody>
                    {riders.slice()
                      .sort(function (a, b) {
                        switch (racerTeamSortBy + ';' + racerTeamSortOrder) {
                          case 'lastNames;asc':
                            return a.lastNames.localeCompare(b.lastNames)
                              || a.firstNames.localeCompare(b.firstNames);
                          case 'lastNames;desc':
                            return b.lastNames.localeCompare(a.lastNames)
                              || b.firstNames.localeCompare(a.firstNames);
                          case 'climbingProb;asc': return a.training.Climbing.probability - b.training.Climbing.probability;
                          case 'climbingProb;desc': return b.training.Climbing.probability - a.training.Climbing.probability;
                          case 'flatProb;asc': return a.training.Flat.probability - b.training.Flat.probability;
                          case 'flatProb;desc': return b.training.Flat.probability - a.training.Flat.probability;
                          case 'downhillProb;asc': return a.training.Downhill.probability - b.training.Downhill.probability;
                          case 'downhillProb;desc': return b.training.Downhill.probability - a.training.Downhill.probability;
                          case 'timeTrialProb;asc': return a.training.TimeTrial.probability - b.training.TimeTrial.probability;
                          case 'timeTrialProb;desc': return b.training.TimeTrial.probability - a.training.TimeTrial.probability;
                          case 'sprintProb;asc': return a.training.Sprint.probability - b.training.Sprint.probability;
                          case 'sprintProb;desc': return b.training.Sprint.probability - a.training.Sprint.probability;
                          default: return a.lastNames.localeCompare(b.lastNames)
                            || a.firstNames.localeCompare(b.firstNames);
                        }
                      })
                      .filter(rider => rider.age > 20).map((rider, index) => (
                        <tr>
                          <td className="td-infotable" style={{ textAlign: "left" }}>
                            <a href="#" onClick={() => showRiderInfo(rider)} style={{ color: '#000000' }}>
                              {rider.firstNames + ' ' + rider.lastNames}
                            </a>
                          </td>
                          <td className="td-infotable px-3" style={getProbabilityFormatStyle(rider.training.Climbing.probability)}>{rider.training.Climbing.probability}%</td>
                          <td className="td-infotable px-3" style={getProbabilityFormatStyle(rider.training.Flat.probability)}>{rider.training.Flat.probability}%</td>
                          <td className="td-infotable px-3" style={getProbabilityFormatStyle(rider.training.Downhill.probability)}>{rider.training.Downhill.probability}%</td>
                          <td className="td-infotable px-3" style={getProbabilityFormatStyle(rider.training.TimeTrial.probability)}>{rider.training.TimeTrial.probability}%</td>
                          <td className="td-infotable px-3" style={getProbabilityFormatStyle(rider.training.Sprint.probability)}>{rider.training.Sprint.probability}%</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </>
        }
      </div>
      

    </div>;
  else return null;
}

export default Training;